export const NEWS_DIGESTS_CHANGE_DISPLAY = 'NEWS_DIGESTS_CHANGE_DISPLAY';



// WEBPACK FOOTER //
// ./src/redux_related/newsDigestsDisplay/actions.js